module.exports = __webpack_public_path__ + "f4334b2e5d62cd297935ae3e94cf28e2.svg";